import { BillingMethodSummaryContainer } from '@/features/billing/components/BillingMethodList/BillingMethodSummaryContainer'
import { useFeatures } from '@/contexts/root-store-context'
import { type SubmissionStatusModalViewModel } from '@/features/jobs/drafting/SubmissionStatusModalViewModel'
import { observer } from 'mobx-react-lite'
import { SubmissionStatusModal } from '@/features/jobs/drafting/components/JobCreation/Submission/SubmissionStatusModal'

export interface SubmissionStatusModalContainerProps {
  vm: SubmissionStatusModalViewModel
}

export const SubmissionStatusModalContainer = observer(
  function SubmissionStatusModalContainer({
    vm,
  }: SubmissionStatusModalContainerProps) {
    const { shellInfo } = useFeatures(({ shell }) => ({
      shellInfo: shell.shellInfo,
    }))

    return (
      <SubmissionStatusModal
        showing={vm.modal.showing}
        status={vm.status}
        onClose={vm.modal.close}
        error={vm.error}
        jobDisplayName={vm.jobDisplayName}
        paymentMethod={
          !vm.canBypassBilling &&
          vm.paymentMethod && (
            <BillingMethodSummaryContainer billingMethod={vm.paymentMethod} />
          )
        }
        onCreateAnother={vm.copyJob}
        continueTo={vm.continueTo}
        isIllustrationShown={!shellInfo.corporateMode}
      />
    )
  },
)
